import { API } from '@apis'
import { KEY_ACCESS, KEY_CODE, KEY_REFRESH } from '@constants'
import { setLocalStorage } from '@helpers'
import axios from 'axios'

import getRefreshToken from './getRefreshToken'
import { CLIENT_ID, CONFIG, ERROR_400, SECRET } from './utils'

export default async function getToken(code) {
  const url = import.meta.env.VITE_BASE_API_URL + API.GET_TOKEN
  const payload = {
    client_id: CLIENT_ID,
    client_secret: SECRET,
    code,
    redirect_uri: import.meta.env.VITE_BASE_URL,
  }

  try {
    const result = await axios.post(url, payload, CONFIG)

    if (result?.data?.access_token && result.data.refresh_token) {
      setLocalStorage(KEY_CODE, code)
      setLocalStorage(KEY_ACCESS, result.data.access_token)
      setLocalStorage(KEY_REFRESH, result.data.refresh_token)

      return 'PASS'
    }

    return result
  } catch (error) {
    const isError = error?.response?.status === 400
    const isInvalidGrant = error.response.data.error === ERROR_400
    const isRedirect = isError && isInvalidGrant

    return isRedirect ? getRefreshToken({}) : error?.response
  }
}
